// extracted by mini-css-extract-plugin
export var skipAnimation = "_31-0";